export default {
  EMPLOYEES_LOADING: "EMPLOYEES_LOADING",
  GET_EMPLOYEES_SUCCESS: "GET_EMPLOYEES_SUCCESS",
  ADD_EMPLOYEE_SUCCESS: "ADD_EMPLOYEE_SUCCESS",
  UPDATE_EMPLOYEE_SUCCESS: "UPDATE_EMPLOYEE_SUCCESS",
  DELETE_EMPLOYEE_SUCCESS: "DELETE_EMPLOYEE_SUCCESS",
  GET_EMPLOYEE_DETAILS_SUCCESS: "GET_EMPLOYEE_DETAILS_SUCCESS",
};
